import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "\n      menu\n      menu-sub\n      menu-sub-dropdown\n      menu-column\n      menu-rounded\n      menu-gray-600\n      menu-state-bg-light-primary\n      fw-bold\n      py-4\n      fs-6\n      w-275px\n    ",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-item px-3\"><div class=\"menu-content d-flex align-items-center px-3\"><div class=\"symbol symbol-50px me-5\"><img alt=\"Logo\" src=\"media/avatars/150-25.jpg\"></div><div class=\"d-flex flex-column\"><div class=\"fw-bolder d-flex align-items-center fs-5\"> Max Smith <span class=\"badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2\">Pro</span></div><a href=\"#\" class=\"fw-bold text-muted text-hover-primary fs-7\">max@kt.com</a></div></div></div><div class=\"separator my-2\"></div>", 2)
const _hoisted_4 = { class: "menu-item px-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" My Profile ")
const _hoisted_6 = { class: "menu-item px-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "menu-text" }, "My Projects", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "menu-badge" }, [
  /*#__PURE__*/_createVNode("span", { class: "badge badge-light-danger badge-circle fw-bolder fs-7" }, "3")
], -1)
const _hoisted_9 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "menu-title" }, "My Subscription", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_12 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_13 = { class: "menu-item px-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Referrals ")
const _hoisted_15 = { class: "menu-item px-3" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Billing ")
const _hoisted_17 = { class: "menu-item px-3" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Payments ")
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Statements ")
const _hoisted_21 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "View your statements"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"separator my-2\"></div><div class=\"menu-item px-3\"><div class=\"menu-content px-3\"><label class=\"form-check form-switch form-check-custom form-check-solid\"><input class=\"form-check-input w-30px h-20px\" type=\"checkbox\" value=\"1\" checked=\"checked\" name=\"notifications\"><span class=\"form-check-label text-muted fs-7\"> Notifications </span></label></div></div>", 2)
const _hoisted_24 = { class: "menu-item px-5" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" My Statements ")
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_27 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_28 = { class: "menu-title position-relative" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Language ")
const _hoisted_30 = { class: "\n              fs-8\n              rounded\n              bg-light\n              px-3\n              py-2\n              position-absolute\n              translate-middle-y\n              top-50\n              end-0\n            " }
const _hoisted_31 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_32 = { class: "menu-item px-3" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "media/flags/united-states.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" English ")
const _hoisted_35 = { class: "menu-item px-3" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "media/flags/spain.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Spanish ")
const _hoisted_38 = { class: "menu-item px-3" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "media/flags/germany.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" German ")
const _hoisted_41 = { class: "menu-item px-3" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "media/flags/japan.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Japanese ")
const _hoisted_44 = { class: "menu-item px-3" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "media/flags/france.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" French ")
const _hoisted_47 = { class: "menu-item px-5 my-1" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Account Settings ")
const _hoisted_49 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _hoisted_8
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: "/pages/profile/overview",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: "/pages/profile/overview",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_router_link, {
            to: "/pages/profile/overview",
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_router_link, {
            to: "/pages/profile/overview",
            class: "menu-link d-flex flex-stack px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              _hoisted_21
            ]),
            _: 1
          })
        ]),
        _hoisted_22
      ])
    ]),
    _createVNode("div", _hoisted_24, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_25
        ]),
        _: 1
      })
    ]),
    _hoisted_26,
    _createVNode("div", _hoisted_27, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_28, [
            _hoisted_29,
            _createVNode("span", _hoisted_30, [
              _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
              _createVNode("img", {
                class: "w-15px h-15px rounded-1 ms-2",
                src: _ctx.currentLangugeLocale.flag,
                alt: "metronic"
              }, null, 8, ["src"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_31, [
        _createVNode("div", _hoisted_32, [
          _createVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('en'))),
            href: "#",
            class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }]
          }, [
            _hoisted_33,
            _hoisted_34
          ], 2)
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('es'))),
            href: "#",
            class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('es') }]
          }, [
            _hoisted_36,
            _hoisted_37
          ], 2)
        ]),
        _createVNode("div", _hoisted_38, [
          _createVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLang('de'))),
            href: "#",
            class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('de') }]
          }, [
            _hoisted_39,
            _hoisted_40
          ], 2)
        ]),
        _createVNode("div", _hoisted_41, [
          _createVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLang('ja'))),
            href: "#",
            class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('ja') }]
          }, [
            _hoisted_42,
            _hoisted_43
          ], 2)
        ]),
        _createVNode("div", _hoisted_44, [
          _createVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLang('fr'))),
            href: "#",
            class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('fr') }]
          }, [
            _hoisted_45,
            _hoisted_46
          ], 2)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_47, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_48
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_49, [
      _createVNode("a", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}